import React, { Component } from 'react'
import router from 'routing/router/index'
import PropTypes from 'prop-types'
import PageContainer from 'components/Client/PageContainer/PageContainer'
import SessionHandler from 'utils/Client/SessionHandler'
import styles from './App.module.scss'

class App extends Component {

  constructor (props) {
    super(props)
    this.state = {}
    window.clientSessionHandler = new SessionHandler()
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    window.clientSessionHandler.initSession()
    return null
  }

  componentWillUnmount () {
    window.clientSessionHandler.disableSession()
  }

  render () {
    const { location, isInitialLoad, isLoading } = this.props
    const route = location.type

    const Content = router[route]

    return (
      <div className={styles.App}>
        <PageContainer isInitialLoad={isInitialLoad} isLoading={isLoading}>
          <Content {...this.props} />
        </PageContainer>
      </div>
    )
  }

}

App.propTypes = {
  location: PropTypes.object.isRequired,
  primaryPortfolio: PropTypes.object,
  isInitialLoad: PropTypes.bool,
  isLoading: PropTypes.bool
}

App.defaultProps = {
  primaryPortfolio: {},
  isInitialLoad: false,
  isLoading: false
}

export default App



// WEBPACK FOOTER //
// ./src/components/Client/App/App.jsx